import React, { useState } from 'react';
import './IconicFAQ.css';
import OurCompanies from '../Home/OurCompanies';

const IconicFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const searchTerm = '';
  const [selectedCategory, setSelectedCategory] = useState('all');

  // ক্যাটাগরি ভিত্তিক FAQ ডেটা (যেখানে তালিকা দরকার সেখানে array ব্যবহার করা হয়েছে)
  const faqData = [
    // General Questions
    {
      id: 1,
      question: "What is Iconic Unity Group (IUG)?",
      answer: "Iconic Unity Group (IUG) is a diversified business platform established on 03 April 2024. We operate across multiple industries and support sustainable business growth through strategic partnerships, professional management, and shared resources.",
      category: "general"
    },
    {
      id: 2,
      question: "What industries does Iconic Unity Group operate in?",
      answer: {
        intro: "Our businesses operate across a wide range of industries, including:",
        list: [
          "Transportation",
          "Real Estate & Property Development",
          "Digital Solutions",
          "Software & Information Technology",
          "Furniture Manufacturing",
          "Travel & Tourism",
          "Hajj & Umrah Services",
          "Education & Skill Development",
          "Automotive Engineering",
          "GPS Tracking & Fleet Management",
          "Logistics & Transport",
          "International Business"
        ]
      },
      category: "general"
    },
    {
      id: 3,
      question: "What makes Iconic Unity Group different?",
      answer: "Unlike a traditional group of companies, IUG operates as a Business Platform that supports entrepreneurs through strategic investment, business guidance, professional management, and shared corporate resources to build sustainable and successful businesses.",
      category: "general"
    },
    {
      id: 4,
      question: "Where does Iconic Unity Group operate?",
      answer: "Our headquarters is in Bangladesh, and we are expanding our international presence through BD Iconic KSA in the Kingdom of Saudi Arabia.",
      category: "general"
    },

    // Partnership Questions
    {
      id: 5,
      question: "Can entrepreneurs become part of IUG?",
      answer: "Yes. We welcome entrepreneurs and business leaders with innovative ideas, industry expertise, and a long-term vision. Every proposal is evaluated based on its business potential, sustainability, and alignment with our corporate values.",
      category: "partnership"
    },
    {
      id: 6,
      question: "What support does IUG provide to its Sister Concerns?",
      answer: {
        intro: "We provide comprehensive support, including:",
        list: [
          "Strategic Business Planning",
          "Financial Guidance",
          "Administrative Support",
          "Legal & Compliance Assistance",
          "Branding & Marketing",
          "Technology & IT Solutions",
          "Corporate Governance",
          "Shared Office & Infrastructure",
          "Business Development Support"
        ]
      },
      category: "partnership"
    },
    {
      id: 7,
      question: "How can I propose a new business partnership?",
      answer: "You can contact our corporate office or submit your business proposal through our official communication channels. Our Executive Team will review the proposal and contact you if it aligns with our strategic objectives.",
      category: "partnership"
    },

    // Investment Questions
    {
      id: 8,
      question: "Does IUG invest in startup businesses?",
      answer: {
        intro: "Yes. We are committed to supporting innovative and sustainable business ideas. Investment decisions are based on:",
        list: [
          "Business Feasibility",
          "Market Opportunity",
          "Operational Capability",
          "Mutual Agreement & Alignment"
        ]
      },
      category: "investment"
    },
    {
      id: 9,
      question: "Can foreign investors collaborate with IUG?",
      answer: "Yes, we actively encourage international partnerships and investments that align with our growth strategy and socio-economic impact goals.",
      category: "investment"
    },

    // Career Questions
    {
      id: 10,
      question: "Does IUG offer career opportunities or internships?",
      answer: "Yes. As our businesses continue to grow, we regularly recruit talented professionals and offer internship opportunities across different industries. Career opportunities are announced through our official website and recruitment channels.",
      category: "careers"
    },

    // Contact & Support
    {
      id: 11,
      question: "How can I contact Iconic Unity Group?",
      answer: "You can reach us through our official website, email (info@iconicunitygroup.com), phone, or by visiting our corporate office in Bangladesh.",
      category: "contact"
    }
  ];

  const categories = [
    { id: 'all', label: 'All Questions' },
    { id: 'general', label: 'General' },
    { id: 'partnership', label: 'Partnership' },
    { id: 'investment', label: 'Investment' },
    { id: 'careers', label: 'Careers' },
    { id: 'contact', label: 'Contact' }
  ];

  const toggleFAQ = (id) => {
    setActiveIndex(activeIndex === id ? null : id);
  };

  // হেলপার ফাংশন: উত্তরটি সাধারণ স্ট্রিং নাকি অবজেক্ট (তালিকা) তা চেক করে সঠিক UI রেন্ডার করার জন্য
  const renderAnswer = (answer) => {
    if (typeof answer === 'string') {
      return answer;
    }

    return (
      <div>
        {answer.intro && <p style={{ marginBottom: '10px' }}>{answer.intro}</p>}
        {answer.list && (
          <ul style={{
            paddingLeft: '20px',
            margin: '0',
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            listStyleType: 'disc'
          }}>
            {answer.list.map((item, idx) => (
              <li key={idx} style={{ color: '#334155', fontSize: '0.95rem' }}>
                {item}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

  // সার্চ এবং ক্যাটাগরি ফিল্টারিং
  const filteredFAQs = faqData.filter(item => {
    const searchLower = searchTerm.toLowerCase();

    // স্ট্রিং অথবা অবজেক্ট ফিল্টার হ্যান্ডলিং
    let matchesSearch = item.question.toLowerCase().includes(searchLower);

    if (typeof item.answer === 'string') {
      matchesSearch = matchesSearch || item.answer.toLowerCase().includes(searchLower);
    } else if (typeof item.answer === 'object') {
      const introMatch = item.answer.intro?.toLowerCase().includes(searchLower);
      const listMatch = item.answer.list?.some(li => li.toLowerCase().includes(searchLower));
      matchesSearch = matchesSearch || introMatch || listMatch;
    }

    const matchesCategory = selectedCategory === 'all' || item.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  // ২ কলামে ভাগ করার হিসাব (Left & Right Column)
  const half = Math.ceil(filteredFAQs.length / 2);
  const leftCol = filteredFAQs.slice(0, half);
  const rightCol = filteredFAQs.slice(half);

  return (
    <div className="faq-page-master">
      {/* 1. Full Width Banner with Search */}
      <section className="faq-hero-section">
        <div className="faq-hero-content">
          <h1 className="faq-hero-title">HOW CAN WE HELP YOU?</h1>
          <p className="faq-hero-subtitle">Find answers to common questions about Iconic Unity Group</p>

          {/* Search Box */}
          {/* <div className="faq-search-box-container">
            <input
              type="text"
              placeholder="Type your question here (e.g. partnership, support, investment)..."
              className="faq-hero-search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div> */}
        </div>
      </section>

      {/* 2. Centered Content */}
      <div className="faq-content-wrapper">
        <div className="faq-container-1440">

          {/* Category Filter Buttons */}
          <div className="faq-category-filters" style={{ display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap', marginBottom: '30px' }}>
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setSelectedCategory(cat.id)}
                className={`faq-cat-btn ${selectedCategory === cat.id ? 'active' : ''}`}
                style={{
                  padding: '8px 18px',
                  borderRadius: '20px',
                  border: '1px solid #00afe9',
                  backgroundColor: selectedCategory === cat.id ? '#00afe9' : '#ffffff',
                  color: selectedCategory === cat.id ? '#ffffff' : '#00afe9',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
              >
                {cat.label}
              </button>
            ))}
          </div>

          {/* 2-Column Grid Layout */}
          {filteredFAQs.length > 0 ? (
            <div className="faq-grid-container">
              <div className="faq-column">
                {leftCol.map((item) => (
                  <div key={item.id} className={`faq-card ${activeIndex === item.id ? 'active' : ''}`} onClick={() => toggleFAQ(item.id)}>
                    <div className="faq-card-question">
                      <span>{item.question}</span>
                      <span className="faq-arrow-icon">{activeIndex === item.id ? '▲' : '▼'}</span>
                    </div>
                    <div className="faq-card-answer">
                      <div className="faq-answer-content">{renderAnswer(item.answer)}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="faq-column">
                {rightCol.map((item) => (
                  <div key={item.id} className={`faq-card ${activeIndex === item.id ? 'active' : ''}`} onClick={() => toggleFAQ(item.id)}>
                    <div className="faq-card-question">
                      <span>{item.question}</span>
                      <span className="faq-arrow-icon">{activeIndex === item.id ? '▲' : '▼'}</span>
                    </div>
                    <div className="faq-card-answer">
                      <div className="faq-answer-content">{renderAnswer(item.answer)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="faq-no-data" style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
              No results found for "{searchTerm}"
            </div>
          )}

          {/* Still Have Questions CTA */}
          <div style={{
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '16px',
            padding: '32px',
            textAlign: 'center',
            marginTop: '50px',
            marginBottom: "20px"
          }}>
            <h3 style={{ color: '#0f172a', fontWeight: '700', marginBottom: '8px' }}>Still Have Questions?</h3>
            <p style={{ color: '#475569', marginBottom: '16px' }}>If you couldn't find the answer you were looking for, our team is here to help.</p>
            <p style={{ fontWeight: '600', color: '#00afe9', margin: 0 }}>Email: info@iconicunitygroup.com</p>
            <p style={{ fontWeight: '600', color: '#00afe9', margin: 0 }}>Hotline: 01824800900</p>
          </div>

        </div>
      </div>

      <OurCompanies />
    </div>
  );
};

export default IconicFAQ;